"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteHelper = void 0;
exports.RemoteHelper = {
    getComponentPropsBy: function (contentProps, pageProps) {
        if (contentProps === void 0) { contentProps = {}; }
        if (pageProps === void 0) { pageProps = {}; }
        return __assign(__assign({}, contentProps), { __host__: __assign(__assign({}, (contentProps.__host__ || {})), { url: pageProps.url || "", pageProperties: pageProps.properties || {}, datalayerInfo: pageProps.dataLayerGenericInfo || {}, pageTitle: pageProps.title || "", profile: pageProps.profile || "" }) });
    },
    getSelectedValue: function (config) {
        var _a;
        return ((_a = config === null || config === void 0 ? void 0 : config.find(function (element) { return (element === null || element === void 0 ? void 0 : element.selected) === "true"; })) === null || _a === void 0 ? void 0 : _a.value) || "";
    },
    getSelectedAllValues: function (config) {
        var _a;
        return (((_a = config === null || config === void 0 ? void 0 : config.filter(function (element) { return (element === null || element === void 0 ? void 0 : element.selected) === "true"; })) === null || _a === void 0 ? void 0 : _a.map(function (el) { return el.value; })) || []);
    },
    extractValue: function (item) {
        return item.value.value;
    },
    dataFormatter: function (inputDate, singleDigitDate) {
        var dateFormatted = inputDate.substring(5, 16);
        var _a = dateFormatted.split(" "), day = _a[0], month = _a[1], year = _a[2];
        var monthMapping = {
            Jan: "gennaio",
            Feb: "febbraio",
            Mar: "marzo",
            Apr: "aprile",
            May: "maggio",
            Jun: "giugno",
            Jul: "luglio",
            Aug: "agosto",
            Sep: "settembre",
            Oct: "ottobre",
            Nov: "novembre",
            Dec: "dicembre",
        };
        var formattedMonth = monthMapping[month] || month;
        if (singleDigitDate) {
            return "".concat(parseInt(day), " ").concat(formattedMonth, " ").concat(year);
        }
        return "".concat(day, " ").concat(formattedMonth, " ").concat(year);
    },
    getIconClassName: function (icon, overrideObj) {
        if (overrideObj === void 0) { overrideObj = {}; }
        var sectionName = this.getSelectedValue(icon["value"]);
        var iconName = overrideObj[sectionName]
            ? overrideObj[sectionName]
            : sectionName;
        var iconNameWithOutAccents = iconName
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
        return "icon-" + iconNameWithOutAccents;
    },
    getIsPrimaryVisible: function (config, isEditMode) {
        return ((config["VisualizzaWidget"]
            ? this.getSelectedValue(config["VisualizzaWidget"].value) !== "No"
            : true) || isEditMode);
    },
    getPrimaryRemoteContainerStyleData: function (config) {
        return {
            "data-margin-top": config["Margine Superiore"]
                ? this.getSelectedValue(config["Margine Superiore"].value)
                : "0px",
            "data-margin-bottom": config["Margine Inferiore"]
                ? this.getSelectedValue(config["Margine Inferiore"].value)
                : "0px",
            "data-intestazione": config["Intestazione"]
                ? this.getSelectedValue(config["Intestazione"].value)
                : "Versione classica",
        };
    },
};
